var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: "20px",
    height: "30px",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#e0e0e0cc",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M8.383,17.101 c0,0.877,0.669,2.185,1.524,2.271C10.625,22.983,12.996,25.957,16,26c2.982,0.042,5.417-3.017,6.094-6.629 c0.853-0.087,1.52-1.395,1.52-2.271"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#e0e0e0cc",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M8.84,18.966 c0,0-1.958,0.699-3.84,3.264L9,25l-1,2h16l-1-2l4-2.769c-1.882-2.565-3.84-3.264-3.84-3.264"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.77,18.368c-0.031,1.019,0.666,2.029,1.915,2.105c0.881,0.054,1.891-0.39,1.891-1.635c0-0.864-0.678-0.995-1.891-1.088 S11.794,17.578,11.77,18.368z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.23,18.368c0.031,1.019-0.666,2.029-1.915,2.105c-0.881,0.054-1.891-0.39-1.891-1.635c0-0.864,0.678-0.995,1.891-1.088 S20.206,17.578,20.23,18.368z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#e0e0e0cc",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M9.154,11.763 C6.625,12.405,5,13.391,5,14.5C5,16.433,9.925,18,16,18s11-1.567,11-3.5c0-1.111-1.631-2.098-4.166-2.74"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#e0e0e0cc",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M18.939,5 C18.269,5,17.23,5.5,16,5.5S13.75,5,13.061,5C10.877,5,9.817,9.295,9,12.337C9,13.938,13.125,14,16,14s7,0,7-1.662 C22.063,9.122,21.123,5,18.939,5z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpy);
export default __webpack_public_path__ + "static/media/spy.e5000baee3eb21188ba409eda663c016.svg";
export { ForwardRef as ReactComponent };